import React, { memo } from 'react';
import { createUseStyles, Text } from '@Sage/hoi-poi-ui';

import useLoginLiterals from 'lib/useLoginLiterals';

import { TransitionGroup, FadeTransition } from 'components/Transitions';
import CenteredLayout from '../CenteredLayout';

import styles from './styles.js';
const useStyles = createUseStyles(styles, 'Login');

const AuthBox = ({ logo, title, children, iframeURL }) => {
    const classes = useStyles();
    const { t, lang } = useLoginLiterals();

    return (
        <>
            <CenteredLayout iframeURL={iframeURL ? t(iframeURL) : null} lang={lang}>
                <div className={classes.root}>
                    <TransitionGroup>
                        <FadeTransition transitionKey="login" show={true}>
                            <div className={classes.logo}>{logo}</div>
                            <Text className={classes.title} type="h6">
                                {title}
                            </Text>
                            {children}
                        </FadeTransition>
                    </TransitionGroup>
                </div>
            </CenteredLayout>
        </>
    );
};

export default memo(AuthBox);
